import { render, staticRenderFns } from "./initials-badge.vue?vue&type=template&id=a7d5e13c&scoped=true&"
import script from "./initials-badge.vue?vue&type=script&lang=ts&"
export * from "./initials-badge.vue?vue&type=script&lang=ts&"
import style0 from "./initials-badge.vue?vue&type=style&index=0&id=a7d5e13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d5e13c",
  null
  
)

export default component.exports